export const OFFICIAL_CATALOG_CARD_IDS = [
  "base.baksteenhandelsschip",
  "base.goudhandelsschip",
  "base.graanhandelsschip",
  "base.graanmolen",
  "base.houthandelsschip",
  "base.houtzagerij",
  "base.inge",
  "base.markus",
  "base.snelle_jorrit",
  "base.steenbakkerij",
  "base.vrolijke_pien",
  "base.willem",
  "base.wolhandelsschip",
  "base.wolweverij",
] as const;

export const OFFICIAL_CATALOG_LOCALIZATION_IDS = new Set<string>(OFFICIAL_CATALOG_CARD_IDS);
